import { CdkTrapFocus } from '@angular/cdk/a11y';
import { Component, OnInit, inject } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { delay } from 'rxjs/operators';
import { NotificationService } from 'src/app/notification/notification.service';
import { AppFormFieldErrorDisplayComponent } from 'src/app/shared/components/app-form-field-error-display/app-form-field-error-display.component';
import { ButtonComponent } from 'src/app/shared/components/button-with-spinner/button.component';
import { AuthService } from 'src/app/shared/service/auth.service';
import { RouterService, routerConfig } from 'src/app/shared/service/router.service';
import { FormApiValidationError } from '../../shared/model/errors/formApiError.model';
import { BrandLogosComponent } from '../brand-logos/brand-logos.component';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  standalone: true,
  imports: [
    BrandLogosComponent,
    TranslatePipe,
    ButtonComponent,
    MatFormFieldModule,
    MatInput,
    AppFormFieldErrorDisplayComponent,
    ReactiveFormsModule,
    CdkTrapFocus,
  ],
})
export class ForgotPasswordComponent implements OnInit {
  isLoading = false;
  protected form!: UntypedFormGroup;
  private authService = inject(AuthService);
  private formBuilder = inject(UntypedFormBuilder);
  private notificationService = inject(NotificationService);
  private routerService = inject(RouterService);

  get email() {
    return this.form.get('email') as UntypedFormControl;
  }

  ngOnInit() {
    this.form = this.formBuilder.group({
      email: ['', [Validators.email, Validators.required, Validators.minLength(5)]],
    });
  }

  onSubmit() {
    if (this.form.valid) {
      this.isLoading = true;
      this.authService
        .remindPassword(this.email.value)
        .pipe(delay(1000))
        .subscribe(
          () => {
            this.notificationService.success('remind_password');
            this.routerService.navigate(routerConfig.authLogin);
          },
          (er: FormApiValidationError) => {
            er.setOnForm && er.setOnForm(this.form);
            this.isLoading = false;
          },
        );
    }
  }
}
